/**
 * Per-tick pickup check: if the player's tile contains an uncollected flag,
 * collect it. Keeps the picky tile-overlap logic in one place so we can
 * change the rule (e.g. center-of-car overlap vs. AABB) without touching
 * scoring.
 */

import type { GameState } from './types.ts';
import { toTile } from './fixed.ts';
import { collectFlag } from './scoring.ts';

export function checkFlagPickup(state: GameState): GameState {
  const ptx = toTile(state.player.x);
  const pty = toTile(state.player.y);
  const idx = state.flags.findIndex(
    (f) => !f.collected && f.tile.x === ptx && f.tile.y === pty,
  );
  if (idx < 0) return state;
  return collectFlag(state, idx);
}
